// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getAuth } from "firebase/auth";
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAUeKHU29XqAqcV2in6OFj1KVN17HCC8Ek",
  authDomain: "tapf-sample.firebaseapp.com",
  databaseURL: "https://tapf-sample-default-rtdb.firebaseio.com",
  projectId: "tapf-sample",
  storageBucket: "tapf-sample.appspot.com",
  messagingSenderId: "284041167545",
  appId: "1:284041167545:web:ae3c8e005a418b43511168",
  measurementId: "G-FGCVELPKBL"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const functions = getFunctions(app);
const auth = getAuth(app);
export { app, analytics, db, functions, auth };